{
    "0_ALREADY_EXISTS": "\"{0}\" already exists.",
    "0_OF_1": "{0} of {1}",
    "ACCOUNT_ID": "Account ID",
    "ADD": "Add",
    "ADD_REMOVE_FIELDS": "Add/remove fields",
    "AN_ERROR_OCCURED": "An error occurred",
    "APPLY": "Apply",
    "APPLY_CHANGES": "Apply changes",
    "ATTACH": "Attach",
    "ATTACH_AS_LINK": "Attach as Link",
    "ATTACHING": "Attaching...",
    "AUTOMATICALLY_RENAME": "Automatically rename",
    "BACK": "Back",
    "BROWSE": "Browse",
    "CANCEL": "Cancel",
    "CHARACTER_COUNT": "Character count:",
    "CLOSE": "Close",
    "CLOUD": "Cloud",
    "COMMENT": "Comment",
    "CONFIGURE_REPOSITORY_SETTINGS": "Configure Repository Settings",
    "COULD_NOT_SAVE_0": "Could not save \"{0}\".",
    "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Could not save \"{0}\". File type not supported.",
    "DATA": "Data",
    "DATE": "Date",
    "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Date fields must be in the format {0}.",
    "DATE_PROVIDED_IS_INVALID": "The date provided is invalid.",
    "DATE_TIME": "Date/Time",
    "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Date/time fields must be in the format {0}.",
    "DEFAULT_FOLDER": "<Default Folder>",
    "DETAILS": "Details",
    "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Do you want to apply your field changes?",
    "DOCUMENT_NAME_IS_EMPTY": "Document name is empty",
    "DRAG_DROP_FILE": "Drag and drop file",
    "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "An entry named '{0}' already exists in this folder. Please select a different name.",
    "ENTRY_ID": "Entry ID",
    "ENTRY_NAME": "Entry Name",
    "ENTRY_NOT_FOUND": "Entry not found.",
    "ERROR_DOWNLOADING_DOCUMENT": "Error downloading document.",
    "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "An error occurred while connecting to the server.",
    "ERROR_SAVING": "Error saving:",
    "FAILED_TO_OPEN_FOLDER": "Failed to open folder",
    "FAILED_TO_SAVE_COLON": "Failed to save:",
    "FAILED_TO_SAVE_PERIOD": "Failed to save.",
    "FEEDBACK": "Feedback",
    "FIELDS": "Fields",
    "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "This file exceeds the maximum file size of 25MB.",
    "FILE_EXTENSION": "File Extension",
    "FILE_LOCKED": "File is locked.",
    "FILE_MODIFIED": "File Modified",
    "FILE_NAME": "File Name",
    "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Filenames cannot contain a backslash",
    "FOLDER": "Folder",
    "INTEGER": "Integer",
    "LIST": "List",
    "LOADING": "Loading...",
    "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Long fields must be integers between 0 and 3,999,999,999",
    "LONG_INTEGER": "Long Integer",
    "NAME": "Name",
    "NAME_CONFLICT": "Name Conflict",
    "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Need help signing in? Contact your Laserfiche Administrator for help.",
    "NEW_FOLDER": "New Folder",
    "NO": "No",
    "NO_ADDITIONAL_FIELDS_ASSIGNED": "No additional fields assigned",
    "NO_FOLDER_SELECTED": "No folder is selected.",
    "NO_MATCHING_ENTRIES_FOUND": "No matching entries were found",
    "NO_MATCHING_FIELDS_FOUND": "No matching fields were found.",
    "NO_TEMPLATE_ASSIGNED": "No template assigned",
    "NOT_AVAILABLE_WITH_TOKENS": "Not available with tokens",
    "NUMBER": "Number",
    "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Number field must be a valid number",
    "OK": "Ok",
    "ONE_OR_MORE_FIELDS_INVALID": "One or more fields are invalid.",
    "OPEN": "Open",
    "OPEN_IN_LASERFICHE": "Open in Laserfiche",
    "OPTIONAL": "Optional",
    "OR": "or",
    "PARENT_FIELD": "Parent Field",
    "PARENT_ID": "Parent ID",
    "PARENT_NAME": "Parent Name",
    "PLEASE_SELECT_A_FOLDER": "Please select a folder",
    "REASON_FOR_DOWNLOADING": "Reason for Downloading",
    "REFRESH": "Refresh",
    "REMOVE": "Remove",
    "REMOVE_REPOSITORY": "Remove Repository?",
    "REPOSITORY": "Repository",
    "REPOSITORY_COUNT": "Repository Count",
    "REPOSITORY_ID": "Repository ID",
    "REPOSITORY_NAME": "Repository Name",
    "REQUIRED": "Required",
    "REQUIRED_FIELD_IS_EMPTY": "Required field is empty",
    "SAVE_CHANGES": "Save Changes",
    "SAVE_TO_LASERFICHE": "Save to Laserfiche",
    "SAVED_TO_LASERFICHE": "Saved to Laserfiche",
    "SAVED_TO_LASERFICHE_COLON": "Saved to Laserfiche:",
    "SAVED_WITH_MISSING_METADATA": "Saved with missing metadata:",
    "SAVING": "Saving...",
    "SEARCH_FIELDS": "Search fields",
    "SELECT": "Select",
    "SELECT_REASON": "Select a reason",
    "SELF_HOSTED": "Self-Hosted",
    "SESSION_COUNT": "Session Count",
    "SETTINGS": "Settings",
    "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Short fields must be integers between 0 and 64999",
    "SIGN_IN": "Sign in",
    "SIGN_IN_TO_LASERFICHE": "Sign in to Laserfiche",
    "SIGN_OUT": "Sign out",
    "SIGNING_IN": "Signing in...",
    "SIGNING_OUT": "Signing out...",
    "SKIP_THIS_FILE": "Skip this file",
    "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Something went wrong. Please try again later.",
    "SUBMIT": "Submit",
    "SUGGESTION": "Suggestion",
    "TEMPLATE": "Template",
    "TEMPLATE_HAS_FAILED_TO_LOAD": "The template has failed to load.",
    "TEXT": "Text",
    "THANK_YOU_FOR_SUBMISSION": "Thank you for your submission!",
    "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "This field has a maximum allowed length of {0} characters.",
    "THIS_FOLDER_IS_EMPTY": "This folder is empty.",
    "TIME": "Time",
    "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Time fields must be in the format {0}.",
    "UNABLE_TO_LOAD_ALL_FIELDS": "Unable to load all fields:",
    "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Unable to retrieve repository information:",
    "UNKNOWN_ERROR": "Unknown Error.",
    "USER_NAME": "User Name",
    "YES": "Yes"
}